import { Pipe, PipeTransform } from '@angular/core';
import { locale } from '@util/locale';

@Pipe({
  name: 'translatable'
})
export class TranslateDomainPipe implements PipeTransform {

  static transform(
    value: any,
    field: string = 'name',
    casing: 'snake' | 'pascal' = 'pascal'
  ): string {

    if (!value) return value;

    let lang = locale().locale;
    const localeO = locale().getLocale(lang);

    if (!locale().isLocaleDWSSupported(lang)) {
      lang = localeO.fallbackLang;
    }

    // Try to get translations
    const translationsKey = `${field}Translations`;

    if (value[translationsKey]) {
      const translations = value[translationsKey];

      const translated =
        translations?.[lang]
        ?? translations?.[localeO.fallbackLang]
        ?? Object.values(translations)[0];

      if (translated) return translated;
    }

    // Fallback legacy (nameIt, nameEn)
    const suffix =
      casing === 'pascal'
        ? lang.charAt(0).toUpperCase() + lang.slice(1)
        : `_${lang}`;

    const legacyKey = field + suffix;

    if (value[legacyKey]) {
      return value[legacyKey];
    }

    // Ultimate fallback
    return '';
  }

  transform(value: any, field: string = 'name', casing: 'snake' | 'pascal' = 'pascal'): string {
    return TranslateDomainPipe.transform(value, field, casing);
  }
}
